import dayjs from '../../lib/day';

// Two-week rule: when the 1st of next month is this close to the billing
// date, the 1st of the month AFTER next is also allowed (and becomes the
// default) so nobody is forced into a first installment back-to-back with
// their down payment. Keep in sync with the backend twin in
// server/lib/paymentPlans.js / paymentPlanSetup.js.
const FIRST_INSTALLMENT_EXTENSION_WINDOW_DAYS = 14;

const extensionApplies = (billingDate) => {
  const firstOfNextMonth = billingDate.add(1, 'month').startOf('month');
  return firstOfNextMonth.diff(billingDate, 'day') <= FIRST_INSTALLMENT_EXTENSION_WINDOW_DAYS;
};

export const getDefaultFirstInstallmentDate = (date = dayjs()) => {
  const billingDate = dayjs(date).startOf('day');
  const monthsAhead = extensionApplies(billingDate) ? 2 : 1;
  return billingDate.add(monthsAhead, 'month').startOf('month').format('YYYY-MM-DD');
};

export const getLatestFirstInstallmentDate = (
  date = dayjs(),
  { extendedWindow = false } = {},
) => {
  const billingDate = dayjs(date).startOf('day');
  // Billing managers may schedule the first installment anywhere in the next
  // 3 calendar months; clients keep the legacy window. Keep in sync with the
  // backend twin (calculateLatestFirstInstallmentDate in paymentPlanSetup.js).
  if (extendedWindow) {
    return billingDate.add(3, 'month').endOf('month').format('YYYY-MM-DD');
  }
  const thirtyDaysOut = billingDate.add(30, 'day');
  const firstOfNextMonth = billingDate.add(1, 'month').startOf('month');
  let latest = firstOfNextMonth.isAfter(thirtyDaysOut) ? firstOfNextMonth : thirtyDaysOut;
  if (extensionApplies(billingDate)) {
    const firstOfMonthAfterNext = billingDate.add(2, 'month').startOf('month');
    if (firstOfMonthAfterNext.isAfter(latest)) latest = firstOfMonthAfterNext;
  }
  return latest.format('YYYY-MM-DD');
};
